module.exports = __webpack_public_path__ + "static/img/ct_qt_4.7bda34f5.png";